import { ApiEndpointHandler, createPostEndpoint } from '@sonar-software/sonar-http';

export type PostInitiativeSonarObjectsRequest = {
	initiativeId: number;
	initiativeTitle: string;
	sonarObjectIds: Array<number>;
};

export type PostInitiativeSonarObjectsResponse = {
	ids: Array<number>;
	initiativeId: number;
	initiativeTitle: string;
};

const postInitiativeSonarObjectsBase = createPostEndpoint<
	PostInitiativeSonarObjectsRequest,
	PostInitiativeSonarObjectsResponse
>(({ initiativeId }) => `/api/v2/initiatives/${initiativeId}/Add-SonarObjects`, {
	requestTransform: ({ sonarObjectIds }) => ({ sonarObjectIds })
});

export const postInitiativeSonarObjects: ApiEndpointHandler<
	PostInitiativeSonarObjectsRequest,
	PostInitiativeSonarObjectsResponse
> = async(request) => {
	const result = await postInitiativeSonarObjectsBase(request);

	if (result.data) {
		result.data.initiativeId = request.initiativeId;
		result.data.initiativeTitle = request.initiativeTitle;
	}

	return result;
};
